let unique = 1;
export class Condition {
    constructor(data = {}) {
        unique += 1;
        this.unique = unique;
        this.roles = (data.roles || []).map((i) => ({
            value: i.name,
            label: i.description,
        }));
        this.posts = (data.posts || []).map((i) => ({
            value: i.code,
            label: i.name,
        }));
        this.columns = (data.columns || []).map((i) => i.code);
    }

    getData() {
        return {
            roles: this.roles.map((r) => r.value),
            posts: this.posts.map((p) => p.value),
            columns: this.columns,
        };
    }
}
